<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2" class="pa-0 d-none d-sm-block">
          <SideMenu/>
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="10" class="nav-right px-3 py-0 pl-sm-14 mt-10">
          <v-parallax height="auto" src="@/assets/images/back-page.webp">
            <div class="dashboard">
              <v-row class="pa-0">
                <v-col cols="12" class="pa-0">
                  <v-card color="transparent" class="form-card" >
                    <div class="text-left">
                      <v-container class="mb-15 mt-10" v-if="postulations.actually.length === 0 && postulations.lasted.length === 0">
                        <v-row>
                          <v-col cols="12">
                            <h4 v-if="getUser.firstName && getUser.lastName">¡Hola {{ getUser.firstName }} {{ getUser.lastName }}!</h4>
                          </v-col>
                          <v-col cols="12">
                            <h2>Mis Postulaciones</h2>
                          </v-col>
                          <v-col cols="12">
                            <v-card color="#E2F7FF" height="300" class="text-center">
                              <v-container bg fill-height grid-list-md text-xs-center>
                                <v-layout row wrap align-center>
                                  <v-flex>
                                    <h2 class="title-postulate">Aún no has postulado a ninguna oferta laboral en nuestra plataforma</h2>
                                    <v-icon class="my-5" style="transform: rotate(180deg);" large>mdi-download</v-icon>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-container class="mt-10 pa-0" v-else>
                        <v-row class="text-left text-md-left px-0">
                          <v-col cols="12" class="px-5">
                            <h1>Mis Postulaciones</h1>
                          </v-col>
                          <v-col cols="12" class="px-5">
                            <h3>Postulaciones activas</h3>
                          </v-col>
                          <v-col cols="12" class="rounded-xl px-5" v-if="!postulations.actually || postulations.actually.length === 0">
                            <p>NO HAY POSTULACIONES RECIENTES</p>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="10" class="rounded-xl px-5" v-else>
                            <v-card class="col-12 mx-0 my-7 pa-0 rounded-xl" v-for="postulation in postulations.actually" :key="postulation.id" :disabled="postulation.status.public && postulation.status.public === 'cancelled'">
                              <v-list-item class="three-line white--text blue pa-3" color="blue">
                                <v-row align="center" class="pa-0 ma-0">
                                  <v-col cols="2" sm="2" md="2" lg="2" class="d-none d-md-block px-2 py-0">
                                    <v-list-item-avatar size="80" class="ma-0 my-auto">
                                      <v-img
                                        :src="getLogo(postulation.offer.alias !== null && postulation.offer.alias !== '' ? '' : postulation.offer.organization)"
                                        alt="offer"
                                      ></v-img>
                                    </v-list-item-avatar>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="6" lg="6" class="pa-0">
                                    <v-list-item-content class="white--text d-flex">
                                      <v-list-item-title class="title">
                                        {{ postulation.offer.title }}
                                      </v-list-item-title>
                                      <v-list-item-subtitle class="white--text d-flex mt-2">
                                        <p class="ma-0">Postulado {{date(postulation.createdAt)}}</p>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-col>
                                  <v-col cols="11" sm="11" md="4" lg="4">
                                    <v-btn
                                      class="col-3 ms-3 btn-show"
                                      outlined
                                      block
                                      color="primary"
                                      @click="showProfile(postulation)"
                                    >
                                      VER POSTULACIÓN
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item class="pa-0 elevation-0">
                                <v-stepper alt-labels class="col-12 pa-0 blue lighten-4 rounded-b-xl">
                                  <div class="d-flex justify-space-between">
                                    <small class="blue--text ma-3">Estado de la publicación</small>
                                    <small class="blue--text ma-3">Fin de la publicación {{ toSlashDate(postulation.offer.validity.end)}}</small>
                                  </div>
                                  <v-stepper-header class="elevation-0">
                                    <v-stepper-step
                                      step=""
                                      :complete="true"
                                    >
                                      <!-- :complete="!!postulation.status && postulation.status === 'sent' ? true:false || !!postulation.status.public && postulation.status.public === 'sent' ? true:false" -->
                                      <small class="blue--text">Recibiendo Postulacion</small>
                                    </v-stepper-step>

                                    <v-divider />

                                    <v-stepper-step
                                      step=""
                                      :complete="postulation.offer.status === 'disable' || postulation.offer.status === 'close' || itsEndPublication(postulation)"
                                    >
                                      <!-- :complete="!!postulation.status && postulation.status === 'interviewing' ? true:false || !!postulation.status.public && postulation.status.public === 'interviewing' ? true:false" -->
                                      <small class="blue--text">Entrevistando</small>
                                    </v-stepper-step>

                                    <v-divider />

                                    <v-stepper-step
                                      step=""
                                      :complete="postulation.offer.status === 'close'"
                                    >
                                      <!-- :complete="!!postulation.status && postulation.status === 'hired' ? true:false || !!postulation.status.public && postulation.status.public === 'hired' ? true:false" -->
                                      <small class="blue--text">Cerrado</small>
                                    </v-stepper-step>
                                  </v-stepper-header>
                                </v-stepper>
                              </v-list-item>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="12" sm="12" class="px-5">
                            <h3>Postulaciones anteriores</h3>
                          </v-col>
                          <v-col cols="12" md="12" sm="12" class="rounded-xl px-5" v-if="!postulations.lasted || postulations.lasted.length === 0">
                            <p>NO HAY POSTULACIONES ANTERIORES</p>
                          </v-col>
                          <v-col cols="12" md="12" sm="12" class="rounded-xl px-5" else>
                            <v-card class="col-12 col-sm-10 col-md-11 col-lg-10 mx-0 my-7 pa-0 rounded-xl" v-for="postulation in postulations.lasted" :key="postulation.id">
                              <v-list-item class="pa-4 three-line white--text blue" color="blue">
                                <v-list-item-avatar size="80" class="ma-0 my-auto col-2">
                                  <img
                                    :src="getLogo(postulation.offer.alias !== null ? '' : postulation.offer.organization.media.logo)"
                                    alt="offer"
                                  >
                                </v-list-item-avatar>
                                <v-list-item-content class="white--text d-flex col-6">
                                  <v-list-item-title class="title">
                                    {{ postulation.offer.title }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle class="white--text d-flex mt-2">
                                    <p>Postulado el {{ date(postulation.createdAt) }}</p>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-btn
                                  class="col-3 ms-3 btn-show"
                                  outlined
                                  color="primary"
                                  @click="showProfile(postulation)"
                                >
                                  VER POSTULACIÓN
                                </v-btn>
                              </v-list-item>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-row justify="center" align="center">
                        <v-col cols="11" md="11" sm="11">
                          <v-card class="mx-auto">
                            <v-card-title>
                              Publicaciones Recomendadas
                            </v-card-title>
                            <v-card-text >
                              <v-col class="d-flex justify-start blue--text" cols="12">
                                <v-col cols="5">
                                  <small>Cargo</small>
                                </v-col >
                                <v-col cols="5">
                                  <small>Organización</small>
                                </v-col>
                                <v-col cols="2">
                                </v-col>
                              </v-col>
                              <v-col class="d-flex justify-start" cols="12" v-for="offer in recommended" :key="offer.id">
                                <v-col cols="5" class="py-0">
                                  {{ offer.title }} <br>
                                  <small class="blue--text text--lighten-3">
                                    Del {{offer.validity.start}} al {{offer.validity.end}}
                                  </small>
                                </v-col >
                                <v-col cols="5" class="py-0 blue--text">
                                  <v-btn
                                    class="primary--text"
                                    text
                                    :to="`/organization/profile/${offer.organization.slug}`"
                                  >
                                    {{ offer.organization.name.charAt(0).toUpperCase()}}{{offer.organization.name.slice(1).toLowerCase()}}
                                  </v-btn>
                                </v-col>
                                <v-col cols="2" class="py-0 justify-center text-center">
                                  <v-btn
                                    dark
                                    color="#3BADFF"
                                    small
                                    :to="{ name: 'OfferShow', params: { slug: offer.slug }}"
                                  >
                                    VER
                                  </v-btn>
                                </v-col>
                              </v-col>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-parallax>
        </v-col>
      </v-row>
    </v-container>

    <CandidateDialog
      :dialog="dialog"
      :candidate="profile"
      :offer="profile && profile.offer"
      @close="(value) => dialog = value"
    />

    <Footer />
  </div>
</template>

<script>
import SideMenu from "@/components/SideMenu";
import CandidateDialog from "@/components/CandidateDialog";
import { userComputed } from "@/store/helpers.js";
import { currentImg, meta } from "../libs/mixins";

export default {
    name: "CandidateDashboard",

    props: ["posts"],

    components: {
        CandidateDialog,
        SideMenu,
    },

    mixins: [currentImg, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Mis postulaciones",
        });
    }, 

    data() {
        return {
            loading: false,
            isLoadingCancel: false,
            currentlyPostulated: [],
            postulations: {
                actually: [],
                lasted: []
            },
            recommended: [],
            dialog: true,
            profile: null,
        };
    },

    created() {
        this.order(this.posts);
        this.recommended = this.getMatch; 
    },

    computed: {
        ...userComputed,
    },

    methods: {
        itsEndPublication(postulation) {
            let [year, month, day] = postulation.offer.validity.end.split("-");
            let end = new Date(year, month - 1, parseInt(day) + 1);
            let today = new Date();
            return today > end;
        },
        showProfile(value) {
            this.profile = value;
            this.dialog = true;
        },
        order(posts) {
            // Se define un limite para ofertas que no tienen fecha de cierre y son anteriores al mes de lanzamiento de la aplicación
            let limit = new Date(2020, 11, 1);
            let now = new Date();

            posts.forEach(post => {
                if (post.offer.status === "close" && post.offer.closeAt != null) {
                    let [year, month, day] =  post.offer.closeAt.split("-");
                    let twoDays = new Date(new Date(year, month - 1, day).getTime() + (3600 * 48 * 1000));
                    if (now >= twoDays) {
                        this.postulations.lasted.push(post);
                    } else {
                        this.postulations.actually.push(post);
                    }
                } else {
                    let [year, month, day] = post.offer.createdAt.slice(0, 10).split("-");
                    let created = new Date(year, month - 1, day);

                    if (created < limit && post.offer.closeAt === null) this.postulations.lasted.push(post);
                    else this.postulations.actually.push(post);
                }
            });
            this.postulations.actually = this.postulations.actually.sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
            });
            this.postulations.lasted = this.postulations.lasted.sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
            });
        },
        toSlashDate(value) {
            if (value && value.includes("-")) {
                let [year, month, day] = value.split("-");
                return `${day}/${month}/${year}`;
            }
            return "";
        },
        date(ts) {
            const now = new Date(ts);
            return now.getDate() + "/" + (now.getMonth() + 1) + "/" + now.getFullYear();
        },
        del(postulation) {
            this.isLoadingCancel = true;
            this.$store.dispatch("users/postUpdate", {
                offerId: postulation.offer.id,
                postulations: [
                    {
                        id: postulation.id,
                        status: {
                            private: postulation.status.private,
                            public: "cancelled"
                        }
                    }
                ],
            }).then(() => {
                this.postulations[0].every(item => {
                    if (postulation.id === item.id) {
                        item.status.public = "cancelled";
                    }
                });
                this.isLoadingCancel = false;
            }).catch(err => {
                console.error(err);
                this.isLoadingCancel = false;
            });
        }
    },
};
</script>

<style scoped>
.logo-job{
    border-radius:50px;
    margin:0 auto;
}
.btn-show, .btn-cancel{
    background-color: white;
}
</style>
